var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 36,
    fill: "#0098FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90067 32.7216C5.67979 32.3231 5.82376 31.821 6.22224 31.6001L44.7072 10.2676C45.1057 10.0467 45.6078 10.1907 45.8287 10.5891L59.8758 35.9309C60.0967 36.3294 59.9527 36.8315 59.5543 37.0523L21.0693 58.3849C20.6708 58.6058 20.1687 58.4618 19.9478 58.0633L5.90067 32.7216Z",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1911 43.8926L36.6003 41.0228",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5857 24.7606L29.1764 27.6304",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0012 28.2955L36.4709 27.3389C36.049 26.5778 35.3439 26.0144 34.5108 25.7727C33.6776 25.531 32.7846 25.6307 32.0282 26.05L26.3242 29.2118C25.5678 29.6311 25.0099 30.3355 24.7734 31.1702C24.5369 32.0049 24.641 32.9014 25.0629 33.6625L25.5932 34.6191C26.0151 35.3802 26.7202 35.9436 27.5533 36.1853C28.3865 36.427 29.2795 36.3273 30.0359 35.908L35.7399 32.7462C36.4963 32.3269 37.3893 32.2272 38.2225 32.4689C39.0557 32.7106 39.7608 33.274 40.1827 34.0351L40.7129 34.9917C41.1348 35.7528 41.239 36.6493 41.0024 37.484C40.7659 38.3187 40.2081 39.0231 39.4517 39.4424L33.7477 42.6042C32.9913 43.0235 32.0983 43.1232 31.2651 42.8815C30.4319 42.6398 29.7268 42.0764 29.3049 41.3153L28.7747 40.3587",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1061 27.7844L13.6363 28.741C14.6207 30.5169 14.8637 32.6087 14.3118 34.5563C13.7599 36.5039 12.4583 38.1476 10.6934 39.1259L9.74274 39.6529",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8232 14.0829L38.3535 15.0395C39.3379 16.8155 40.9831 18.13 42.9272 18.694C44.8713 19.2581 46.955 19.0253 48.7199 18.047L49.6706 17.52",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9528 54.5697L27.4226 53.6131C26.4381 51.8372 24.7929 50.5226 22.8488 49.9586C20.9048 49.3946 18.8211 49.6273 17.0561 50.6057L16.1055 51.1326",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6697 40.8687L52.1395 39.9121C51.1551 38.1362 50.9121 36.0444 51.464 34.0968C52.0159 32.1493 53.3175 30.5055 55.0824 29.5272L56.0331 29.0002",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1508 56.6771L25.8719 59.782C26.0928 60.1805 26.5949 60.3245 26.9933 60.1036L65.4783 38.771C65.8768 38.5501 66.0208 38.048 65.7999 37.6496L51.7527 12.3078C51.5318 11.9093 51.0298 11.7654 50.6313 11.9862L47.5501 13.6942",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 60H57.5",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 60H67.5",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 63V67",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 53V57",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12H9.5",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12H19.5",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15V19",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5V9",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/cash-icon.3401ea89779114d2f738067ec9cf5453.svg";
export { ForwardRef as ReactComponent };